<template>
  <div>
    <section>
      <header>
        <el-breadcrumb>
          <!--        组织架构-->
          <el-breadcrumb-item>{{
            $t("message.organizationalStructure")
          }}</el-breadcrumb-item>
          <!--        用户列表-->
          <el-breadcrumb-item>{{ $t("message.usersList") }}</el-breadcrumb-item>
          <!--        编辑角色、可进入系统信息-->
          <el-breadcrumb-item>{{
            $t("message.editRolesAndAccessSystemInformation")
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </header>
      <footer>
        <div class="footerText">
          {{ $t("message.editRolesAndAccessSystemInformation") }}
        </div>
        <div class="operationContainer">
          <div class="flexAndCenter">
            <!--            角色        请选择角色 -->
            <div class="label">{{ $t("message.newRole") }}</div>
            <el-input v-model="roleName" @focus="showSelectRoleContainer"
              :placeholder="$t('message.pleaseSelectRoles')" />
          </div>
          <div class="flexAndCenter">
            <!--            可进入子系统         请选择子系统 -->
            <div class="label">
              {{ $t("message.accessToSubsystems") }}
            </div>
            <el-select v-model="systemOptionList" multiple :placeholder="$t('message.pleaseSelectSubsystem')">
              <el-option v-for="item in systemList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flexAndCenter" style="margin-top: 48px">
          <!--        保存-->
          <el-button @click="submitBindRole" type="primary" style="margin: 0 16px 0 40px">{{ $t("message.save")
            }}</el-button>
          <!--        返回-->
          <el-button @click="$router.go(-1)">{{
            $t("message.return")
          }}</el-button>
        </div>
      </footer>
      <!--角色选择-->
      <el-dialog :title="$t('message.roleChoices')" :close-on-click-modal="false" :visible.sync="dialogVisible"
        width="40%" :before-close="handleClose">
        <div class="roleChoicesContainer" style="background: #f8f8f8; border-radius: 0 8px 8px 8px">
          <div class="flexAndCenter roleChoicesHeaderContainer">
            <div class="flexAndCenter">
              <div style="width: 60px">{{ $t("message.newRole") }}</div>
              <!--角色-->
              <el-input v-model="input" style="width: 400px; margin-right: 40px" placeholder="请输入内容" />
            </div>
            <el-button type="primary">{{ $t("message.confirm") }}</el-button><!--         确定-->
          </div>
          <div style="margin-top: 20px">
            <el-checkbox-group v-model="userRoleList">
              <el-checkbox v-for="(item, index) in roleList" :key="index" :label="item.id">
                {{ item.name }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <!--      保存-->
          <el-button type="primary" @click="saveRole">{{
            $t("message.save")
          }}</el-button>
        </span>
      </el-dialog>
    </section>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      input: "",
      systemList: [],
      newRoleList: [],
      roleList: [],
      roleName: "",
      dialogVisible: false,
      systemOptionList: [],
      userRoleList: [],
      ruleForm: {
        roleSet: [],
        systemSet: [],
      },
    };
  },
  created() {
    this.getAccountNumberList();
    this.getSubSystemList();
    this.getRoleList();
  },
  methods: {
    handleClose(done) {
      // 确认关闭？
      this.$confirm(this.$t("message.sureToClose"))
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    //提交账号要绑定的角色和子系统
    submitBindRole() {
      //是否要保存该账号绑定的角色和可进入系统信息                         提示
      this.$confirm(
        this.$t(
          "message.whetherToSaveTheRoleBoundToTheAccountAndTheInformationThatCanBeAccessedToTheSystem"
        ),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.confirm"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.roleApi
            .bindRole({
              id: this.$route.query.id,
              roleSet: this.userRoleList,
              systemSet: this.systemOptionList,
            })
            .then((res) => {
              this.$message.success(res.msg);
              setTimeout(() => {
                this.$router.go(-1);
              }, 1000);
            });
        })
        .catch((err) => {
          this.$message({
            type: "info",
            message: this.$t("message.theAdditionHasBeenCanceled"), //已取消添加
          });
        });
    },
    //保存选中的角色
    saveRole() {
      let arr = [];
      let roleName = "";
      this.roleList.forEach((item) => {
        this.userRoleList.forEach((items) => {
          if (item.id === items) {
            arr.push(item.id);
            roleName += item.name + "、";
          }
        });
      });
      roleName = roleName.substring(0, roleName.length - 1);
      this.dialogVisible = false;
      this.roleName = roleName;
      this.userRoleList = arr;
    },
    //展示选择角色弹窗，匹配已经有的角色
    showSelectRoleContainer() {
      this.roleList.forEach((item) => {
        this.userRoleList.forEach((items) => {
          if (item.id === items) {
            item.checked = true;
          }
        });
      });
      this.dialogVisible = true;
    },
    //获取要修改的账号信息
    getAccountNumberList() {
      this.$api.roleApi
        .accountNumberList({
          id: this.$route.query.id,
        })
        .then((res) => {
          let roleName = "";
          this.systemOptionList = [];
          res.data.data.forEach((item) => {
            item.admin_system.forEach((items) => {
              this.systemOptionList.push(items.system_id);
            });
            item.role.forEach((items) => {
              this.userRoleList.push(items.id);
              roleName += items.name + "、";
            });
          });
          roleName = roleName.substring(0, roleName.length - 1);
          this.roleName = roleName;
        });
    },
    //获取子系统列表
    getSubSystemList() {
      this.$api.roleApi.subsystemList().then((res) => {
        this.systemList = res.data;
      });
    },
    getRoleList() {
      this.$api.roleApi
        .roleList({
          page: 1,
          pageSize: 999999999999999,
          searchText: this.input,
        })
        .then((res) => {
          console.log(res);
          res.data.data.forEach((item) => {


            if (this.userRoleList.length !== 0) {
              this.userRoleList.forEach((items) => {
                if (item.id === items) {
                  item.checked = true;
                }
              });
            } else {
              item.checked = false;
            }
          });
          this.roleList = res.data.data;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-checkbox {
  margin-bottom: 20px;
}

.operationContainer {
  display: flex;

  .flexAndCenter {
    flex: 1;
    margin-right: 40px;

    .el-select {
      width: 100%;
    }

    .label {
      width: 120px;
    }
  }
}

.flexAndCenter {
  display: flex;
  align-items: center;
}

section {
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  header {
    border-radius: 8px;
    background: #f8f8f8;
    padding: 24px;
    margin-bottom: 24px;
  }

  footer {
    border-radius: 8px;
    background: #f8f8f8;
    padding: 24px;

    .footerText {
      color: #999999;
      margin-bottom: 30px;
    }
  }
}

.roleChoicesContainer {
  margin: 0 40px;
  border-radius: 0 8px 8px 8px;
  background: #f8f8f8;
  padding: 24px;
}
</style>